import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import { selectTreatmentPlan } from '../../../../treatment/state/plan/selector'
import { createValidationMessage } from '../../../../validation/create-validation-message'

export default {
    taskName: taskName.REVIEW_TREATMENT_PLAN,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER,
        },
        {
            component: processUI.SALES_ORDER_CUSTOMER_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.TREATMENT_VISUALIZATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.IPR_INSTRUCTIONS_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.ATTACHMENT_NEEDED_WIDGET,
            readOnly: false,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_DURATION_WIDGET_CONTAINER,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_CLASSIFICATION_WIDGET_CONTAINER,
            readOnly: true,
        },
        {
            component: processUI.PRE_TREATMENT_REASON_WIDGET_CONTAINER,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_PLAN_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
        },
        {
            component: processUI.SCAN_FILE_UPLOAD_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.CUSTOMER_XRAY_FILE_UPLOAD,
        },
        {
            component: processUI.TREATMENT_PLAN_FILE_UPLOAD_WIDGET,
            readOnly: true,
        },
    ],
    actionList: [
        {
            action: processAction.PROCESS_INSTANCE,
            taskPath: ['processInstance'],
        },
        {
            action: processAction.TREATMENT_PLAN,
            taskPath: ['objectDetail', 'customer', 'treatmentPlanList', 0],
        },
        {
            action: processAction.SALES_ORDER,
            taskPath: ['objectDetail'],
        },
        {
            action: processAction.CUSTOMER,
            taskPath: ['objectDetail', 'customer'],
        },
        {
            action: processAction.QUOTATION_CUSTOMER_LOADED,
            taskPath: ['objectDetail', 'customer'],
        },
    ],
    taskValidatorSelector: [
        selectProcessContext, selectTreatmentPlan,
    ],
    taskValidator: (task, processInstance, taskName, eventName, context, treatmentPlan) => {
        const messageList = []

        const { treatmentType, treatmentReason } = treatmentPlan

        if (treatmentType === null) {
            messageList.push(
                createValidationMessage(
                    "Treatment Type is mandatory field for Medical/Non Medical Treatment Classification.",
                    "treatmentPlan.treatmentType"
                )
        );
        }

        if (treatmentType === 'medical' && treatmentReason === null) {
            messageList.push(
                createValidationMessage(
                    "Treatment Reason is mandatory field for Medical Treatment.",
                    "treatmentPlan.treatmentReason"
                )
            );
        }

        if (eventName === 'cannot_be_treated') {
            const cannotBeTreatedReason = context.cannotBeTreatedReason
            if (!cannotBeTreatedReason) {
                messageList.push(createValidationMessage("Please add the reason for 'cannot be treated' before proceeding.", 'checkDeliveryTracking.checkDeliveryTracking'))
            }
            return messageList
        }

        return messageList
    }
}



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/review-treatment-plan.js